import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .table {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--sds-typography-family-body);
    background: var(--sds-color-background-default-default);
    transition: background-color 0.2s ease;
  }

  .table th {
    text-align: left;
    padding: var(--sds-size-space-400) var(--sds-size-space-600);
    font-weight: var(--sds-typography-weight-medium);
    font-size: var(--sds-typography-body-size-small);
    color: var(--sds-color-text-default-secondary);
    border-bottom: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    transition:
      color 0.2s ease,
      border-color 0.2s ease;
  }

  .table td {
    padding: var(--sds-size-space-400) var(--sds-size-space-600);
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-default-default);
    border-bottom: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    transition:
      color 0.2s ease,
      border-color 0.2s ease;
  }

  .table.hoverable tbody tr {
    cursor: pointer;
  }

  .table.hoverable tbody tr:hover td {
    background: var(--sds-color-background-default-default-hover);
  }

  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .empty-message {
    text-align: center;
    padding: var(--sds-size-space-800);
    color: var(--sds-color-text-default-secondary);
    font-size: var(--sds-typography-body-size-medium);
    transition: color 0.2s ease;
  }

  .table th.sortable {
    cursor: pointer;
    user-select: none;
  }

  .header-content {
    display: inline-flex;
    align-items: center;
    gap: var(--sds-size-space-200);
  }

  .sort-icon {
    color: var(--sds-color-icon-default-secondary);
    flex-shrink: 0;
    transition: color 0.2s ease;
  }

  /* Mobile view */
  .mobile-view {
    display: flex;
    flex-direction: column;
  }

  .tile {
    border-bottom: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    padding: var(--sds-size-space-400);
    background: var(--sds-color-background-default-default);
    transition:
      background-color 0.2s ease,
      border-color 0.2s ease;
  }

  .tile-hoverable {
    cursor: pointer;
  }

  .tile-hoverable:hover {
    background: var(--sds-color-background-default-default-hover);
  }

  .mobile-empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tile-skeleton {
    border-radius: var(--sds-size-radius-400);
    overflow: hidden;
  }

  /* Sort menu */
  .sort-menu-container {
    position: relative;
    display: flex;
    justify-content: flex-end;
  }

  .sort-menu-trigger {
    display: inline-flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    padding: var(--sds-size-space-200) var(--sds-size-space-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    background: var(--sds-color-background-default-default);
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    cursor: pointer;
    transition:
      background-color 0.2s ease,
      color 0.2s ease,
      border-color 0.2s ease;
  }

  .sort-menu-trigger:hover {
    background: var(--sds-color-background-default-default-hover);
  }

  .sort-menu-popover {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: var(--sds-size-space-200);
    min-width: 160px;
    background: var(--sds-color-background-default-default);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    box-shadow: 0 4px 12px rgb(0 0 0 / 0.15);
    padding: var(--sds-size-space-200);
    z-index: 1000;
    transition:
      background-color 0.2s ease,
      border-color 0.2s ease;
  }

  .sort-menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: var(--sds-size-space-300) var(--sds-size-space-400);
    border: none;
    border-radius: var(--sds-size-radius-200);
    background: none;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    cursor: pointer;
    text-align: left;
    transition:
      background-color 0.2s ease,
      color 0.2s ease;
  }

  .sort-menu-item:hover {
    background: var(--sds-color-background-default-default-hover);
  }
`;
